
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/tmp/codebuild/output/src1312/src/codestar-connections.us-east-1.amazonaws.com/git-http/694641143822/us-east-1/f058762b-1820-4ccd-b63a-b0d8128357ce/clearview/asifa-members-fe/sentry.client.config.ts")
            }
          });